(function () {
    'use strict';
    var controllerId = 'tmxstore';
    var TMX_PROVIDER_NAME = 'tmxstore';
    angular.module('app').controller(controllerId, ['$q', '$state', '$resource', 'authenticationOriginService', 'tmxStoreProductService', 'tmxStoreSubscriptionService', 'tmxStorePoliciyService', tmxstore]);

    function tmxstore($q, $state, $resource, authenticationOriginService, tmxStoreProductService, tmxStoreSubscriptionService, tmxStorePoliciyService) {
        var scope = this;
        var origin = authenticationOriginService.getOriginInfo();

        scope.requestTmx = function ($scope) {

            if (origin.providerName == TMX_PROVIDER_NAME) {
                if (origin.isValid != 'True') {
                    $state.go('error', { errorReason: origin.errorReason });
                } else {
                    tmxStoreSubscriptionService.getClientSubscription("BobSmith@email.com").then(function (response) {
                        // API keys
                        scope.apiKey1 = response.primaryKey;
                        scope.apiKey2 = response.secondaryKey;

                        // Products
                        var subscriptionDatas = response.subscriptionData;
                        scope.products = [];
                        subscriptionDatas.forEach(function (subData) {
                            tmxStoreProductService.getProductById(subData.productId).then(function (productResponse) {


                                var productData = productResponse.productData;

                                var apiPoliciesInfo = [];

                                productData.forEach(function (productInfo) {
                                    var path = productInfo.path;
                                    var policies = [];
                                    //paths.push(productInfo.path);
                                    var policyIds = productInfo.policyIds;
                                    policyIds.forEach(function (policyId) {
                                        tmxStorePoliciyService.getPolicyById(policyId).then(function (policyResponse) {
                                            policies.push({ type: policyResponse.type, value: policyResponse.value });
                                        });
                                    });

                                    apiPoliciesInfo.push({
                                        path: path,
                                        policies: policies
                                    });
                                });

                                scope.products.push({
                                    name: productResponse.name,
                                    description: productResponse.description,
                                    apiPoliciesInfo: apiPoliciesInfo,
                                    createdDate: new Date(subData.createdDate).toLocaleDateString(),
                                    endDate: new Date(subData.endDate).toLocaleDateString(),
                                    expirationDate: new Date(subData.expirationDate).toLocaleDateString(),
                                    startDate: new Date(subData.startDate).toLocaleDateString()
                                });

                                var debug = true;
                            });

                        });
                    });
                }
            } else {
                $state.go('error', "You don't have permissions to visit this page");
            }
        }

        this.requestTmx();
    }

})();